
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
props: ['memberId'],
components: {
XHeader,
Group,
Cell,
XButton
},
data() {
return {
member: {info: {}},
pageLoaded: false,
}
},
computed: {
userLevel() {
let al = this.member.info.agent_level;
let isAgent = this.member.info.is_agent;
let ul = this.member.info.level;
if (isAgent > 0) {
return al === 3 ? '区县代' :
(al === 2 ? '代理' :
(al === 1 ? '省级代理' : ''));
} else {
return ul === 1 ? '普通用户' :
(ul === 2 ? '初级用户' :
(ul === 3 ? '中级用户' :
(ul === 4 ? '高级用户' : '')));
}
}
},

created: function () {
document.title = this.memberId + '的个人信息';
this.$vux.loading.show({
'text': '加载中'
});
const url = this.tianYiWebUrl + '/wechat/uc/ajaxGetMemberInfo';
this.$http.get(url, {params: {uid: this.memberId}}).then(r => {
let res = r.data;
if (res.code === 200) {
this.member = res.data;
this.pageLoaded = true;
this.$vux.loading.hide();
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/uc/ReferInfo.vue